/**
 * Client application that initiated a request.
 * Sent as the `X-Channel` header for persistence/analytics on auth verify and bookings.
 * Not used for authorization or UI behavior.
 */
export type ClientChannel =
  | 'MAIN_WEB_APP'
  | 'IOS_APP'
  | 'ANDROID_APP'
  | 'LANDING_WEB_APP';

/** Channel for this CRA main web app (customer, host, tutor, admin shells). */
export const MAIN_WEB_APP_CHANNEL: ClientChannel = 'MAIN_WEB_APP';

export const CLIENT_CHANNEL_HEADER = 'X-Channel';

export const clientChannelHeader = (channel: ClientChannel) => ({
  [CLIENT_CHANNEL_HEADER]: channel,
});
